module.exports = __webpack_public_path__ + "img/insuflavelGrandeAzul.4bded4db.svg";